<template>
  <section id="contents">
  	<div id="title_block">
  		<h1 class="title_text">ログイン</h1>
  		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
  	</div>
  	<div class="login_warp">
  		<div class="inner">
  			<p class="read_text">DroneAgentが提供するサービスをご利用になるにはログインが必要です</p>
  			<div class="login_box">
          <form @submit.prevent="login">
            <p><input type="text" placeholder="メールアドレス" v-model="username" required></p>
            <p><input type="password" placeholder="パスワード" v-model="password" required></p>
  					<p class="checkbox">
  						<input type="checkbox" id="remember_me" v-model="rememberMe">
  						<label for="keep_pass">ログインしたままにする</label>
  					</p>
  					<p class="submit"><input type="submit" value="ログイン"></p>
  				</form>
          <p class="btn_new"><router-link :to="'/signup?app_id='+this.app_id">新規登録<span>(無料)</span></router-link></p>
  			</div>
        <p class="note">※パスワードをお忘れの方は<router-link to="/forgot-password">こちら</router-link></p>
        <p class="note">※ メール確認は<router-link :to="'/confirm?app_id='+this.app_id">こちら</router-link></p>
  		</div>
  	</div>
    <id-logo/>
  </section>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import Logo from './Logo'

export default {
  name: 'Login',
  components : {
    'id-logo' : Logo 
  },
  data () {
    return {
      app_id: '',
      redirect: '',
      username: '',
      password: '',
      rememberMe: '',
      loginUrl: ''
    }
  },
  mounted () {
    var client_id = this.$route.query.app_id
    var loginUrl = process.env.SERVICES[client_id]
    if (loginUrl) {
      this.app_id = client_id
      this.loginUrl = loginUrl
    }
    if (this.$route.query.redirect) {
      this.redirect = decodeURIComponent(this.$route.query.redirect)
    }
    this.$cognito.isAuthenticated().then(session => {
      this.$emit('updateLogin', true)
      if (this.loginUrl) {
        var config = {
          headers: { 
            'id-token': session.idToken.jwtToken,
            'access-token': session.accessToken.jwtToken,
            'refresh-token': session.refreshToken.token
          }
        }
        if (this.app_id == 'camp') {
          const url = this.loginUrl + '?uid=' + this.username + '&idToken=' + session.idToken.jwtToken + '&accessToken=' + session.accessToken.jwtToken + '&refreshToken=' + session.refreshToken.token
          window.location.href = url
        } else {
          if (this.app_id == 'ec') config['withCredentials'] = true 
          axios.get(this.loginUrl, config)
            .then((res) => {
              if (res.status == 200) {
                if (this.redirect) {
                  window.location.href = res.data.url + this.redirect
                } else {
                  console.log('youuuuu')
                  window.location.href = res.data.url
                }
              } else {
                this.$router.replace('/home')
              }
            })
        }
      } else {
        this.$router.replace('/home')
      }
    }).catch(session => { })
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          this.$emit('updateLogin', true)
          if (this.loginUrl) {
            var config = {
              headers: { 
                'id-token': result.idToken.jwtToken,
                'access-token': result.accessToken.jwtToken,
                'refresh-token': result.refreshToken.token
              }
            }
            if (this.app_id == 'camp') {
              window.location.href = this.loginUrl
                + '?uid=' +  this.username
                + '&idToken=' + result.idToken.jwtToken
                + '&accessToken=' + result.accessToken.jwtToken
                + '&refreshToken=' + result.refreshToken.token
            } else {
              if (this.app_id == 'ec') config['withCredentials'] = true 
              axios.get(this.loginUrl, config)
                .then((res) => {
                  if (res.status == 200) {
                    if (this.redirect) {
                     window.location.href = res.data.url + this.redirect
                    } else {
                     window.location.href = res.data.url
                    }
                  } else {
                    this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.login.login_fail") })
                    this.$router.replace('/home')
                  }
                })
            }
          } else {
            this.$router.replace('/home')
          }
        })
        .catch(err => {
        console.log(err)
          this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.login." + err.code) })
        })
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/login.css'
</style>



// WEBPACK FOOTER //
// src/components/Login.vue